import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToolService } from '@app/core/services/tool.service';
import { PartNumber } from '@app/shared/models/partNumber.model';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Tool } from '@app/tool/model/tool.model';
import { ToolSet } from '@app/tool/model/toolSet.model';
import { Log } from 'ng2-logger';

@Component({
    selector: 'app-part-number-tools-form',
    templateUrl: './part-number-tools-form.component.html',
    styleUrls: ['./part-number-tools-form.component.scss']
})
export class PartNumberToolsFormComponent implements OnInit {
    _logger = Log.create(PartNumberToolsFormComponent.name);

    @Input() showValidations;
    @Input() tools = [];
    @Input() selectedTools = [];
    @Input() mode: string;
    @Input() loading: boolean;
    @Input() toolConfig = new TableConfig();
    @Input() selectedToolsConfig = new TableConfig();

    public unselectedTools = [];

    public partNumber: PartNumber;
    public displayOnlySelected = false;



    @Output() toolsPageChange: EventEmitter<any> = new EventEmitter();
    @Output() toolsSortChange: EventEmitter<any> = new EventEmitter();
    @Output() toolsFilterChange: EventEmitter<any> = new EventEmitter();
    @Output() toolsGroupChange: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
        this.displayOnlySelected = false;
        this.tools = [];
        this.selectedTools = [];
        this.unselectedTools = [];
    }

    public init(partNumber: PartNumber) {
        this.partNumber = partNumber;
    }

    public getFormDetails() {
        return {tools: [...this.selectedTools]};
    }

    public resetForm() {
        this.displayOnlySelected = false;
        this.tools = [];
        this.selectedTools = [];
        this.unselectedTools = [];
    }

    onToolsPageChange(tableState) {
        this.toolsPageChange.emit(tableState);
    }

    onToolsSortChange(tableState) {
        this.toolsSortChange.emit(tableState);
    }

    onToolsFilterChange(tableState) {
        this.toolsFilterChange.emit(tableState);
    }

    onToolsFilterGroupChange(tableState) {
    }

    onToolsGroupChange(tableState) {
        this.toolsGroupChange.emit(tableState);
    }

    onToolClicked(toolDetails: { checked: boolean, group: Tool | ToolSet }) {
        if (toolDetails.checked) {
            this.selectedTools.push(toolDetails.group);
            const index = this.unselectedTools.findIndex(item => item.id === toolDetails.group.id);
            if (index > -1) {
                this.unselectedTools.splice(index, 1);
            }
        } else {
            this.unselectedTools.push(toolDetails.group);
            const index = this.selectedTools.findIndex(item => item.id === toolDetails.group.id);
            if (index > -1) {
                this.selectedTools.splice(index, 1);
            }
        }
        this.selectedToolsConfig.pager.count = this.selectedTools.length;
    }

    onChangeView() {
        this.displayOnlySelected = !this.displayOnlySelected;
    }

    public isReadOnly() {
        return this.mode === 'view';
    }
}
